import { useQuery } from '@tanstack/react-query';
import { getPaymentSummary } from '../services';
import { mapSemiMonthlySummaryResponse } from '../utils/mapSemiMonthlySummaryResponse';

export default function useGetPaymentSummary({ service, endDate }) {
  return useQuery({
    queryKey: ['paymentSummary', service, endDate],
    queryFn: () => getPaymentSummary({ service, endDate }),
    enabled: !!service && !!endDate,
    select: (data) => {
      if (!data?.data) return null;
      return mapSemiMonthlySummaryResponse(data);
    },
    staleTime: 1000 * 60 * 60,
  });
}
